import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import Footer from "../components/footer/Footer";
// import { faSquareCheck, faCheck } from "@fortawesome/free-solid-svg-icons";

const TermsAndConditions = () => {
  return (
    <div className="bg-black pb-20">
      {/* header */}
      <Navbar className="static" />

      {/* <Link to="/login">
        <div className="px-32 mt-10 text-white font-medium flex space-x-2">
          <FontAwesomeIcon icon={faArrowLeft} className="w-5 h-auto" />
          <div>Back</div>
        </div>
      </Link> */}

      <div className="mt-14 px-5 sm:px-10 xl:px-16 2xl:px-32 w-min text-white">
        <Link
          to="/login"
          className="bg-slate-900 border border-slate-800 rounded-full p-2"
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
            className="w-5 h-5 text-white/800 cursor-pointer pt-0.5"
          />
        </Link>
      </div>

      <div className="cardBorder1 borderFN mx-3 xs:mx-5 sm:mx-10 xl:mx-16 2xl:mx-32 mt-5">
        <div id="grad" className="rounded-lg">
          <div className="font-body pb-10">
            <div className="bg-gradient-to-r from-[#0c0c0c] via-[#444444] to-[#0c0c0c] rounded-t-xl">
              <h2 className="text-white text-xl text-left px-5 lg:px-10 py-2.5">
                Terms of Service
              </h2>
            </div>
            <h2 className="font-body text-lg sm:text-xl md:text-2xl lg:text-3xl font-normal text-center text-slate-100 px-5 md:px-20 xl:px-40 py-5 lg:leading-10">
              Welcome to the TRACKLIMO (“TRACKLIMO”) website located at
              www.TRACKLIMO.com (the “Site”).
            </h2>

            <h2 className="font-body text-lg sm:text-xl font-normal text-center text-slate-100 px-5 md:px-20 xl:px-40 py-5 lg:leading-10 xl:leading-8">
              Please read these Terms of Service &nbsp;
              <Link to="../TermsConditions" className="hover:underline">
                (https://TRACKLIMO.com/TermsConditions)
              </Link>
              &nbsp;(the “Terms”) and our Privacy Policy&nbsp;
              <Link to="../PrivacyPolicy" className="hover:underline">
                (www.TRACKLIMO.com/PrivacyPolicy)
              </Link>
              &nbsp; carefully because they govern your use of our Site and our
              mobile device application TRACKLIMO(“App”). To make these Terms
              easier to read, the Site and App are collectively called the
              “Services.”
            </h2>
            <div className="px-5 lg:px-10 mt-16 mb-6 text-slate-100">
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white pb-6">
                I. AGREEMENT TO TERMS
              </h2>

              <h2 className="font-body py-1 leading-6">
                By using our Services, you agree to be bound by these Terms. If
                you don’t agree to be bound by these Terms, do not use the
                Services. If you are accessing and using the Services on behalf
                of a company (such as your employer) or other legal entity, you
                represent and warrant that you have the authority to bind that
                company or other legal entity to these Terms. In that case,
                “you” and “your” will refer to that entity.
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                II. PRIVACY POLICY
              </h2>
              <h2 className="font-body py-1">
                Please refer to our Privacy Policy{" "}
                <Link
                  to="../PrivacyPolicy"
                  className="text-blue-500 hover:underline"
                >
                  (www.TRACKLIMO.com/PrivacyPolicy)
                </Link>
                &nbsp; for information on how we collect, use, share, and
                disclose information from our users. You acknowledge and agree
                that your use of the Services is subject to our Privacy Policy.
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                III. CHANGES TO TERMS OR SERVICES
              </h2>
              <h2 className="font-body py-1">
                We may modify the Terms at any time, in our sole discretion. If
                we do so, we’ll let you know either by posting the modified
                Terms on the Site or through other communications. It’s
                important that you review the Terms whenever we modify them
                because if you continue to use the Services after we have posted
                modified Terms on the Site, you are indicating to us that you
                agree to be bound by the modified Terms. If you don’t agree to
                be bound by the modified Terms, then you may not use the
                Services anymore. Because our Services are evolving over time we
                may change or discontinue all or any part of the Services, at
                any time and without notice, at our sole discretion.
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                IV. ARBITRATION NOTICE
              </h2>
              <h2 className="font-body py-1">
                UNLESS YOU OPT OUT OF ARBITRATION WITHIN 30 DAYS OF THE DATE YOU
                FIRST AGREE TO THESE TERMS BY FOLLOWING THE OPT-OUT PROCEDURE
                SPECIFIED IN THE “ARBITRATION” SECTION BELOW, AND EXCEPT FOR
                CERTAIN TYPES OF DISPUTES DESCRIBED IN THE “ARBITRATION“ SECTION
                BELOW, YOU AGREE THAT DISPUTES BETWEEN YOU AND TRACKLIMO WILL BE
                RESOLVED BY BINDING, INDIVIDUAL ARBITRATION AND YOU ARE WAIVING
                YOUR RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE AS A PLAINTIFF
                OR CLASS MEMBER IN ANY PURPORTED CLASS ACTION OR REPRESENTATIVE
                PROCEEDING.
              </h2>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                V. WHO MAY USE THE SERVICES
              </h2>
              <div className="ml-10">
                <h2 className="font-body py-1">
                  <p className="font-semibold pb-3">1. Eligibility.</p>
                  You may use the Services only if you are or 13 years or older
                  (or such other minimum age at which you can provide consent to
                  data processing under the laws of your territory), and are not
                  barred from using the Services under applicable law.
                </h2>
                <h2 className="font-body py-3">
                  <p className="font-semibold pb-3">
                    2. Registration and Your Information.
                  </p>
                  If you want to use certain features of the Services you’ll
                  have to create an account (“Account”). It’s important that you
                  provide us with accurate, complete and up-to-date information
                  for your Account and you agree to update such information, as
                  needed, to keep it accurate, complete and up-to-date. If you
                  don’t, we might have to suspend or terminate your Account. You
                  agree that you won’t disclose your Account password to anyone
                  and you’ll notify us immediately of any unauthorized use of
                  your Account. You’re responsible for all activities that occur
                  under your Account, whether or not you know about them.
                </h2>
                <h2 className="font-body py-3">
                  <p className="font-semibold pb-3">3. Feedback.</p>
                  We welcome feedback, comments and suggestions for improvements
                  to the Services (“Feedback”). You can submit Feedback by
                  emailing us at support@drivado.com. If you choose to submit
                  Feedback, you agree that we are free to use it without any
                  restriction or compensation to you. You grant to us a
                  non-exclusive, worldwide, perpetual, irrevocable, fully-paid,
                  royalty-free, sublicensable and transferable license under any
                  and all intellectual property rights that you own or control
                  to use, copy, modify, create derivative works based upon and
                  otherwise exploit the Feedback for any purpose.
                </h2>
                <h2 className="font-body py-3">
                  <p className="font-semibold pb-3">
                    4. Content and Content Rights.
                  </p>
                  For purposes of these Terms: (i) “Content” means files,
                  documents, text, graphics, images, music, software, audio,
                  video, works of authorship of any kind, and information or
                  other materials that are posted, generated, provided or
                  otherwise made available through the Services; and (ii) “User
                  Content” means any Content that Account holders (including
                  you) provide to be made available through the Services, other
                  than Feedback. Content includes without limitation User
                  Content.
                </h2>
                <h2 className="font-body py-3">
                  <p className="font-semibold pb-3">
                    5. Content Ownership, Responsibility and Removal.
                  </p>
                  TRACKLIMO does not claim any ownership rights in any User
                  Content and nothing in these Terms will be deemed to restrict
                  any rights that you may have to use and exploit your User
                  Content. Subject to the foregoing, TRACKLIMO and its licensors
                  exclusively own all right, title and interest in and to the
                  Services and Content, including all associated intellectual
                  property rights. You acknowledge that the Services and Content
                  are protected by copyright, trademark, and other laws of the
                  United States and foreign countries. You agree not to remove,
                  alter or obscure any copyright, trademark, service mark or
                  other proprietary rights notices incorporated in or
                  accompanying the Services or Content.
                </h2>
                <h2 className="font-body py-1">
                  <span className="font-semibold">
                    6. Rights in User Content Granted by You.
                  </span>
                </h2>
                <div className="ml-6 mt-3">
                  <h2>
                    <b>6.a.</b>&nbsp; By making any User Content available
                    through Services you hereby grant to TRACKLIMO a
                    non-exclusive, transferable, sublicensable, worldwide,
                    royalty-free license to use, copy, modify, create derivative
                    works based upon, distribute, publicly display, publicly
                    perform and distribute your User Content in connection with
                    operating and providing the Services and Content to you and
                    to other Account holders in connection with operating and
                    providing the Services.
                  </h2>
                  <br />
                  <h2>
                    <b>6.b.</b>&nbsp; You are solely responsible for all your
                    User Content. You represent and warrant that you have (and
                    will have) all rights that are necessary to grant us the
                    license rights in your User Content under these Terms. You
                    also represent and warrant that neither your User Content,
                    nor your use and provision of your User Content to be made
                    available through the Services, nor any use of your User
                    Content by TRACKLIMO on or through the Services will
                    infringe, misappropriate or violate a third party’s
                    intellectual property rights, or rights of publicity or
                    privacy, or result in the violation of any applicable law or
                    regulation.
                  </h2>
                  <br />
                  <h2>
                    <b>6.c.</b>&nbsp; You can remove your User Content by
                    specifically deleting it. However, in certain instances,
                    some of your User Content (such as posts or comments you
                    make) may not be completely removed and copies of your User
                    Content may continue to exist on the Services. To the
                    maximum extent permitted by law, we are not responsible or
                    liable for the removal or deletion of (or the failure to
                    remove or delete) any of your User Content.
                  </h2>
                </div>
                <h2 className="font-body py-5">
                  <p className="font-semibold pb-3">
                    7. Rights in Content Granted by TRACKLIMO.
                  </p>
                  Subject to your compliance with these Terms, TRACKLIMO grants
                  you a limited, non-exclusive, non-transferable,
                  non-sublicensable license to download, view, copy, display and
                  print the Content solely in connection with your permitted use
                  of the Services and solely for your personal and
                  non-commercial purposes.
                </h2>
              </div>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                VI. RIGHTS AND TERMS FOR APPS
              </h2>
              <div className="ml-10">
                <h2 className="font-body py-3">
                  <p className="font-semibold mb-3">
                    1.a. Rights in App Granted by TRACKLIMO
                  </p>
                  Subject to your compliance with these Terms, TRACKLIMO grants
                  you a limited non-exclusive, non-transferable,
                  non-sublicensable license to download and install a copy of
                  the App on a mobile handsets, tablets, wearable device,
                  personal computer, and/or other devices and to run such copy
                  of the App solely for your own personal non-commercial
                  purposes. Except as expressly permitted in these Terms, you
                  may not: (i) copy, modify or create derivative works based on
                  the App; (ii) distribute, transfer, sublicense, lease, lend or
                  rent the App to any third party; (iii) reverse engineer,
                  decompile or disassemble the App; or (iv) make the
                  functionality of the App available to multiple users through
                  any means. TRACKLIMO reserves all rights in and to the App not
                  expressly granted to you under these Terms.
                </h2>
                <h2 className="font-body py-3">
                  <p className="font-semibold mb-3">
                    1.b. Additional Information: Apple App Store
                  </p>
                  This Section 6(b) applies to any App that you acquire from the
                  Apple App Store or use on an iOS device. Apple has no
                  obligation to furnish any maintenance and support services
                  with respect to the App. In the event of any failure of the
                  App to conform to any applicable warranty, you may notify
                  Apple, and Apple will refund the App purchase price to you (if
                  applicable) and, to the maximum extent permitted by applicable
                  law, Apple will have no other warranty obligation whatsoever
                  with respect to the App. Apple is not responsible for
                  addressing any claims by you or any third party relating to
                  the App or your possession and use of it, including, but not
                  limited to: (i) product liability claims; (ii) any claim that
                  the App fails to conform to any applicable legal or regulatory
                  requirement; and (iii) claims arising under consumer
                  protection or similar legislation. Apple is not responsible
                  for the investigation, defense, settlement and discharge of
                  any third-party claim that your possession and use of the App
                  infringe that third party’s intellectual property rights.
                  Apple and its subsidiaries, are third-party beneficiaries of
                  these Terms, and upon your acceptance of the Terms, Apple will
                  have the right (and will be deemed to have accepted the right)
                  to enforce these Terms against you as a third-party
                  beneficiary thereof. You represent and warrant that (i) you
                  are not located in a country that is subject to a U.S.
                  Government embargo, or that has been designated by the U.S.
                  Government as a terrorist-supporting country; and (ii) you are
                  not listed on any U.S. Government list of prohibited or
                  restricted parties. You must also comply with any applicable
                  third-party terms of service when using the App.
                </h2>
                <h2 className="font-body py-3">
                  <p className="font-semibold mb-3">
                    2. General Prohibitions and TRACKLIMO’s Enforcement Rights
                  </p>
                  You agree not to do any of the following:
                </h2>
                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.a.</span> Post, upload,
                  publish, submit or transmit any Content that: (i) infringes,
                  misappropriates or violates a third party’s patent, copyright,
                  trademark, trade secret, moral rights or other intellectual
                  property rights, or rights of publicity or privacy; (ii)
                  violates, or encourages any conduct that would violate, any
                  applicable law or regulation or would give rise to civil
                  liability; (iii) is fraudulent, false, misleading or
                  deceptive; (iv) is defamatory, obscene, pornographic, vulgar
                  or offensive; (v) promotes discrimination, bigotry, racism,
                  hatred, harassment or harm against any individual or group;
                  (vi) is violent or threatening or promotes violence or actions
                  that are threatening to any person or entity; or (vii)
                  promotes illegal or harmful activities or substances.
                </h2>
                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.b.</span> Use, display,
                  mirror or frame the Services or any individual element within
                  the Services, TRACKLIMO’s name, any TRACKLIMO trademark, logo
                  or other proprietary information, or the layout and design of
                  any page or form contained on a page, without TRACKLIMO’s
                  express written consent;
                </h2>
                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.c.</span> Access,
                  tamper with, or use non-public areas of the Services,
                  TRACKLIMO’s computer systems, or the technical delivery
                  systems of TRACKLIMO’s providers;
                </h2>
                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.d.</span> Attempt to
                  probe, scan or test the vulnerability of any TRACKLIMO system
                  or network or breach any security or authentication measures;
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.e.</span> Avoid,
                  bypass, remove, deactivate, impair, descramble or otherwise
                  circumvent any technological measure implemented by TRACKLIMO
                  or any of TRACKLIMO’s providers or any other third party
                  (including another user) to protect the Services or Content;
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.f.</span> Attempt to
                  access or search the Services or Content or download Content
                  from the Services using any engine, software, tool, agent,
                  device or mechanism (including spiders, robots, crawlers, data
                  mining tools or the like) other than the software and/or
                  search agents provided by TRACKLIMO or other generally
                  available third-party web browsers;
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.g.</span> Send any
                  unsolicited or unauthorized advertising, promotional
                  materials, email, junk mail, spam, chain letters or other form
                  of solicitation;
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.h.</span> Use any meta
                  tags or other hidden text or metadata utilizing a TRACKLIMO
                  trademark, logo URL or product name without TRACKLIMO’s
                  express written consent;
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.i.</span> Use the
                  Services or Content, or any portion thereof, for any
                  commercial purpose or for the benefit of any third party or in
                  any manner not permitted by these Terms;
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.j.</span> Forge any
                  TCP/IP packet header or any part of the header information in
                  any email or newsgroup posting, or in any way use the Services
                  or Content to send altered, deceptive or false
                  source-identifying information;
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.k.</span> Attempt to
                  decipher, decompile, disassemble or reverse engineer any of
                  the software used to provide the Services or Content;
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.l.</span> Interfere
                  with, or attempt to interfere with, the access of any user,
                  host or network, including, without limitation, sending a
                  virus, overloading, flooding, spamming, or mail-bombing the
                  Services;
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.m.</span> Collect or
                  store any personally identifiable information from the
                  Services from other users of the Services without their
                  express permission;
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.n.</span> Impersonate
                  or misrepresent your affiliation with any person or entity;
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.o.</span> Violate any
                  applicable law or regulation; or
                </h2>

                <h2 className="font-body py-3 ml-6">
                  <span className="font-semibold mb-3">2.p.</span> Encourage or
                  enable any other individual to do any of the foregoing.
                </h2>
                <h2 className="font-body py-1 ml-6">
                  Although TRACKLIMO is not obligated to monitor access to or
                  use of the Services or Content or to review or edit any
                  Content, we have the right to do so for the purpose of
                  operating the Services, to ensure compliance with these Terms,
                  and to comply with applicable law or other legal requirements.
                  We reserve the right, but are not obligated, to remove or
                  disable access to any Content, at any time and without notice,
                  including, but not limited to, if we, at our sole discretion,
                  consider any Content to be objectionable or in violation of
                  these Terms. We have the right to investigate violations of
                  these Terms or conduct that affects the Services. We may also
                  consult and cooperate with law enforcement authorities to
                  prosecute users who violate the law.
                </h2>
                <h2 className="py-3">
                  <p className="font-semibold mb-3">
                    3. DMCA/Copyright Policy.
                  </p>
                  TRACKLIMO respects copyright law and expects its users to do
                  the same. It is TRACKLIMO’s policy to terminate in appropriate
                  circumstances Account holders who repeatedly infringe or are
                  believed to be repeatedly infringing the rights of copyright
                  holders.
                </h2>
                <h2 className="py-3">
                  <p className="font-semibold mb-3">
                    4. Links to Third Party Websites or Resources.
                  </p>
                  The Services and App may contain links to third-party websites
                  or resources. We provide these links only as a convenience and
                  are not responsible for the content, products or services on
                  or available from those resources or links displayed on such
                  websites. You acknowledge sole responsibility for and assume
                  all risk arising from your use of any third-party resources.
                </h2>
                <h2 className="py-3">
                  <p className="font-semibold mb-3">5. Termination.</p>
                  We may terminate your access to and use of the Services, at
                  our sole discretion, at any time and without notice to you.
                  You may cancel your Account at any time by sending an email to
                  us at support@drivado.com. Upon any termination,
                  discontinuation or cancellation of Services or your Account,
                  the following Sections will survive: 5.6, 6.2, 6.5 through
                  6.8, 7, and 8.
                </h2>
                <h2 className="py-3">
                  <p className="font-semibold mb-3">6. Warranty Disclaimers.</p>
                  THE SERVICES AND CONTENT ARE PROVIDED “AS IS,” WITHOUT
                  WARRANTY OF ANY KIND. WITHOUT LIMITING THE FOREGOING, WE
                  EXPLICITLY DISCLAIM ANY WARRANTIES OF MERCHANTABILITY, FITNESS
                  FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT OR NON-INFRINGEMENT,
                  AND ANY WARRANTIES ARISING OUT OF COURSE OF DEALING OR USAGE
                  OF TRADE. We make no warranty that the Services will meet your
                  requirements or be available on an uninterrupted, secure, or
                  error-free basis. We make no warranty regarding the quality,
                  accuracy, timeliness, truthfulness, completeness or
                  reliability of any information or Content on the Services.
                </h2>
                <h2 className="py-3">
                  <p className="font-semibold mb-3">7. Indemnity.</p>
                  You will indemnify and hold harmless TRACKLIMO and its
                  officers, directors, employee and agents, from and against any
                  claims, disputes, demands, liabilities, damages, losses, and
                  costs and expenses, including, without limitation, reasonable
                  legal and accounting fees arising out of or in any way
                  connected with (i) your access to or use of the Services or
                  Content, (ii) your User Content, or (iii) your violation of
                  these Terms.
                </h2>
                <h2 className="py-3">
                  <p className="font-semibold mb-3">
                    8. Limitation of Liability.
                  </p>
                  TO THE MAXIMUM EXTENT PERMITTED BY LAW, NEITHER TRACKLIMO NOR
                  ITS SERVICE PROVIDERS INVOLVED IN CREATING, PRODUCING, OR
                  DELIVERING THE SERVICES OR CONTENT WILL BE LIABLE FOR ANY
                  INCIDENTAL, SPECIAL, EXEMPLARY OR CONSEQUENTIAL DAMAGES,
                  INCLUDING LOST PROFITS, LOST REVENUES, LOST SAVINGS, LOST
                  BUSINESS OPPORTUNITY, LOSS OF DATA OR GOODWILL, SERVICE
                  INTERRUPTION, COMPUTER DAMAGE OR SYSTEM FAILURE OR THE COST OF
                  SUBSTITUTE SERVICES OF ANY KIND ARISING OUT OF OR IN
                  CONNECTION WITH THESE TERMS OR FROM THE USE OF OR INABILITY TO
                  USE THE SERVICES OR CONTENT, WHETHER BASED ON WARRANTY,
                  CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR
                  ANY OTHER LEGAL THEORY, AND WHETHER OR NOT TRACKLIMO OR ITS
                  SERVICE PROVIDERS HAVE BEEN INFORMED OF THE POSSIBILITY OF
                  SUCH DAMAGE, EVEN IF A LIMITED REMEDY SET FORTH HEREIN IS
                  FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE. TO THE MAXIMUM
                  EXTENT PERMITTED BY LAW OF THE APPLICABLE JURISDICTION, IN NO
                  EVENT WILL TRACKLIMO’S TOTAL LIABILITY ARISING OUT OF OR IN
                  CONNECTION WITH THESE TERMS OR FROM THE USE OF OR INABILITY TO
                  USE THE SERVICES OR CONTENT EXCEED THE LOWER OF: (I) THE
                  AMOUNTS YOU HAVE PAID OR ARE PAYABLE BY YOU TO TRACKLIMO FOR
                  USE OF THE SERVICES OR CONTENT OR ONE HUNDRED DOLLARS ($100),
                  IF YOU HAVE NOT HAD ANY PAYMENT OBLIGATIONS TO TRACKLIMO, AS
                  APPLICABLE. THE EXCLUSIONS AND LIMITATIONS OF DAMAGES SET
                  FORTH ABOVE ARE FUNDAMENTAL ELEMENTS OF THE BASIS OF THE
                  BARGAIN BETWEEN TRACKLIMO AND YOU.
                </h2>
              </div>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                VII. DISPUTE RESOLUTION
              </h2>
              <div className="ml-10">
                <h2 className="font-body py-3">
                  <p className="font-semibold mb-3">1. Governing Law.</p>
                  Governing Law and Dispute Resolution
                  <br />
                  <br />
                  The parties must attempt to amicably settle any dispute
                  arising out of or relating to these Terms through negotiation.
                  If the dispute is not resolved between the parties after at
                  least 30 (thirty) days of negotiation, the dispute must be
                  referred to arbitration before a party may resort to
                  litigation. The arbitration must be: Subject to the laws of
                  India. Any dispute, claim or controversy arising out of or
                  relating to these User Terms or the breach, termination,
                  enforcement, interpretation or validity thereof or the use of
                  the Site, the Service or the Application (collectively,
                  “Disputes”) the parties shall attempt to settle the same
                  amicably, through negotiation and consultation at such offices
                  of TRACKLIMO as TRACKLIMO may designate. In the event the
                  dispute is not resolved internally between after at least 30
                  (thirty) days of negotiation, in good faith, the same shall be
                  subject to binding and final arbitration in accordance with
                  the Arbitration and Conciliation Act, 1996 as amended from
                  time to time or in case the Arbitration and Conciliation Act,
                  1996 is no longer in force, as per any law relating to
                  arbitration in force at the time of such reference. The
                  reference shall be made to a sole arbitrator mutually
                  appointed by TRACKLIMO and You. The place of the arbitration
                  shall be Kolkata ,India, unless otherwise mutually agreed by
                  TRACKLIMO and You in writing. Subject to the above, any
                  Dispute will be subject to the exclusive jurisdiction of
                  courts in Kolkata, India.
                </h2>
                <h2 className="font-body py-3">
                  <p className="font-semibold">2. Agreement to Arbitrate.</p>
                </h2>
                <div className="ml-6">
                  <h2 className="font-body py-2">
                    <span className="font-semibold mb-3">2.a.</span> You and
                    TRACKLIMO agree that any dispute, claim or controversy
                    arising out of or relating to these Terms or the breach,
                    termination, enforcement, interpretation or validity thereof
                    or the use of the Services (collectively, “Disputes”) will
                    be resolved solely by binding individual arbitration and not
                    in a class, representative or consolidated action or
                    proceeding. You and TRACKLIMO agree that the Indian
                    Arbitration and Conciliation Act, 1996 governs the
                    interpretation and enforcement of these Terms, and that you
                    and TRACKLIMO are each waiving the right to a trial by jury
                    or to participate in a class action. This arbitration
                    provision shall survive termination of these Terms.
                  </h2>

                  <h2 className="font-body py-2">
                    <span className="font-semibold mb-3">2.b.</span> As limited
                    exceptions to Section 7.2(a) above: each party retains the
                    right: <br />
                    (i) to seek to resolve a Dispute in small claims court if it
                    qualifies; and <br />
                    (ii) to seek injunctive or other equitable relief in a court
                    to prevent (or enjoin) the infringement or misappropriation
                    of a party’s intellectual property rights (the action
                    described in the foregoing clause (ii), an “IP Protection
                    Action”).
                  </h2>
                </div>
                <h2 className="font-body py-3">
                  <span className="font-semibold mb-3">3.</span> Relief (that
                  is, injunctive relief that has the primary purpose and effect
                  of prohibiting unlawful acts that threaten future injury to
                  the public), the entitlement to and extent of such relief must
                  be litigated in a civil court of competent jurisdiction and
                  not in arbitration. The parties agree that litigation of any
                  issues of public injunctive relief shall be stayed pending the
                  outcome of the merits of any individual claims in arbitration.
                </h2>
              </div>
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white py-5">
                VIII. DISPUTE RESOLUTION
              </h2>
              <div className="ml-10">
                <h2 className="font-body py-3">
                  <p className="font-semibold mb-3">
                    1. Reservation of Rights.
                  </p>
                  TRACKLIMO and its licensors exclusively own all right, title
                  and interest in and to the Services, including all associated
                  intellectual property rights. You acknowledge that the
                  Services are protected by copyright, trademark, and other laws
                  of India.You agree not to remove, alter or obscure any
                  copyright, trademark, service mark or other proprietary rights
                  notices incorporated in or accompanying the Services.
                </h2>
                <h2 className="font-body py-3">
                  <p className="font-semibold mb-3">2. Entire Agreement.</p>
                  These Terms constitute the entire and exclusive understanding
                  and agreement between TRACKLIMO and you regarding the Services
                  and Content, and these Terms supersede and replace all prior
                  oral or written understandings or agreements between TRACKLIMO
                  and you regarding the Services and Content. If any provision
                  of these Terms is held invalid or unenforceable (either by an
                  arbitrator appointed pursuant to the terms of the
                  “Arbitration” section above or by court of competent
                  jurisdiction), that provision will be enforced to the maximum
                  extent permissible and the other provisions of these Terms
                  will remain in full force and effect. You may not assign or
                  transfer these Terms, by operation of law or otherwise,
                  without TRACKLIMO’s prior written consent. Any attempt by you
                  to assign or transfer these Terms, without such consent, will
                  be null. TRACKLIMO may freely assign or transfer these Terms
                  without restriction. Subject to the foregoing, these Terms
                  will bind and inure to the benefit of the parties, their
                  successors and permitted assigns.
                </h2>
                <h2 className="font-body py-3">
                  <p className="font-semibold mb-3">3. Notices.</p>
                  Any notices or other communications provided by TRACKLIMO
                  under these Terms, including those regarding modifications to
                  these Terms, will be given: (i) via email; or (ii) by posting
                  to the Services. For notices made by e-mail, the date of
                  receipt will be deemed the date on which such notice is
                  transmitted.
                </h2>
                <h2 className="font-body py-3">
                  <p className="font-semibold mb-3">4. Waiver of Rights.</p>
                  TRACKLIMO’s failure to enforce any right or provision of these
                  Terms will not be considered a waiver of such right or
                  provision. The waiver of any such right or provision will be
                  effective only if in writing and signed by a duly authorized
                  representative of TRACKLIMO. Except as expressly set forth in
                  these Terms, the exercise by either party of any of its
                  remedies under these Terms will be without prejudice to its
                  other remedies under these Terms or otherwise.
                </h2>
                <h2 className="font-body py-3">
                  <p className="font-semibold mb-3">5. Contact Information.</p>
                  If you have any questions about these Terms or the Services,
                  please contact TRACKLIMO at{" "}
                  <a
                    href="mailto:support@drivado.com"
                    className="text-blue-500 hover:underline"
                  >
                    support@drivado.com
                  </a>{" "}
                  or write to us
                </h2>
                <h2 className="font-body py-3">
                  Drivado Transfers Pvt Ltd
                  <br />
                  P-3 New CIT Road
                  <br /> 4th Floor,
                  <br /> Kolkata - 700073
                  <br /> India
                </h2>
              </div>
            </div>

            {/* <div className="px-5 lg:px-10 text-slate-100 pb-10">
              <h2 className="font-body text-xl lg:text-2xl font-semibold text-white pb-6">
                VIII. Company Identification
              </h2>
              <h2 className="font-body py-1">
                <br />
                The contact details of drivado are as follows:
                <br />
                <br />
                Drivado Transfers Pvt. Ltd.,
                <br />
                Unit #506,
                <br />
                Merlin Infinite DN-51,
                <br />
                Street Number 11, DN Block,
                <br />
                Sector V, Bidhannagar, Kolkata,
                <br />
                West Bengal 700091, India
              </h2>
            </div> */}
          </div>
        </div>
      </div>
      <div className="px-5 sm:px-10 xl:px-16 2xl:px-32">
        <Footer />
      </div>
    </div>
  );
};

export default TermsAndConditions;
